import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from 'material-ui/styles';
import ButtonBase from 'material-ui/ButtonBase';
import CheckCircleIcon from 'material-ui-icons/CheckCircle';
import Typography from 'material-ui/Typography';
import { formatDate } from '../../../../../utils/date-utils';

const styles = theme => ({
  root: {
    width: '100%',
    height: 72,
    background: theme.palette.common.faintBlack,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    userSelect: 'none',
    tapHighlightColor: 'transparent',
  },
  rootEnabled: {
    cursor: 'pointer',
  },
  signed: {
    display: 'flex',
    pointerEvents: 'none',
  },
  signedName: {
    fontWeight: 500,
    pointerEvents: 'none',
  },
  signedIcon: {
    color: theme.palette.primary['A700'],
    marginRight: theme.spacing.unit * 2,
    pointerEvents: 'none',
  },
  bar: {
    width: '100%',
    height: 2,
    position: 'absolute',
    left: 0,
    bottom: 0,
    transformOrigin: '0 0',
    background: theme.palette.primary['A700'],
  },
});

class SignatureWidget extends Component {
  raf;
  lastTime = 0;

  state = {
    enabled: false,
    signing: false,
    progress: 0,
  };

  componentDidMount() {
    const { value, readonly, formContext } = this.props;
    if (!value && !readonly) {
      formContext.onSign();
      this.setState({
        enabled: true,
      });
      //this.raf = requestAnimationFrame(this.updateProgress);
    }
  }

  onMouseDown = event => {
    if (this.raf || this.props.value) return;
    const { isFormValid } = this.props.formContext;
    if (isFormValid) {
      this.lastTime = new Date().getTime();
      this.raf = requestAnimationFrame(this.updateProgress);
      this.setState({
        signing: true,
      });

      document.addEventListener('mouseup', this.clearInteraction);
    }
  };

  clearInteraction = () => {
    const { formContext } = this.props;
    const { isFormValid } = formContext;
    if (false === isFormValid) {
      formContext.onSign();
    }
    if (!this.raf) return;
    cancelAnimationFrame(this.raf);
    this.raf = null;
    const { enabled } = this.state;
    if (enabled) {
      this.setState({
        progress: 0,
        signing: false,
      });
    }

    document.removeEventListener('mouseup', this.clearInteraction);
  };

  onClick = event => {
    this.props.formContext.onSign();
  };

  componentWillUnmount() {
    cancelAnimationFrame(this.raf);
  }

  updateProgress = () => {
    const { progress } = this.state;
    const { onChange } = this.props;
    if (progress === 2) {
      this.setState({ enabled: false });
      cancelAnimationFrame(this.raf);
      onChange(true);
    } else {
      const currentTime = new Date().getTime();
      const delta = (currentTime - this.lastTime) / 1000;
      this.setState({ progress: Math.min(2, Math.max(0, progress + delta)) });
      this.raf = requestAnimationFrame(this.updateProgress);
      this.lastTime = currentTime;
    }
  };

  render() {
    const { classes, value, formContext, readonly } = this.props;
    const { signedBy = { name: '' }, signedAt } = formContext;
    const interactions = value || readonly ? false : true;
    const style = { transform: `scaleX(${this.state.progress / 2})` };
    var label = '';
    const signedDate = signedAt || Date.now();
    const interactionProps = {
      onMouseDown: this.onMouseDown,
      onTouchStart: this.onMouseDown,
      onMouseUp: this.clearInteraction,
      onTouchCancel: this.clearInteraction,
      onTouchEnd: this.clearInteraction,
      onTouchMove: this.clearInteraction,
      onDragStart: this.clearInteraction,
    };

    if (formContext.formSchema.id === "wagri.inspection.wagri") {
      label = this.state.signing ? 'Kinnitatakse...' : 'Kinnita, hoides nuppu all';
    } else {
      label = this.state.signing ? 'Allekirjoitetaan...' : 'Allekirjoita painamalla pitkään';
    }

    return (
      <ButtonBase
        component="div"
        focusRipple
        disableRipple
        disabled={!interactions}
        className={classnames(classes.root, {
          [classes.rootEnabled]: interactions,
        })}
        {...interactionProps}
        onContextMenu={e => e.preventDefault()}
      >
        {value ? (
          <div className={classes.signed}>
            <CheckCircleIcon className={classes.signedIcon} />
            <Typography>
              <span className={classes.signedName}>
                {signedBy.firstName} {signedBy.lastName}
              </span>
              <br />
              {formatDate(signedDate, 'D.M.YYYY')}
            </Typography>
          </div>
        ) : (
          <Typography type="caption">{label}</Typography>
        )}
        <div className={classes.bar} style={style} />
      </ButtonBase>
    );
  }
}

SignatureWidget.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  formContext: PropTypes.object.isRequired,
};

export default withStyles(styles)(SignatureWidget);



// WEBPACK FOOTER //
// ./src/modules/common/components/form/widgets/SignatureWidget.js